
import { useQuery } from "@tanstack/react-query";
import { slideshowHomeprincipal } from "../../../services";






export const useSlideShowHomePrincipal = () => {
    const { data, isLoading } = useQuery({
        queryKey: ['slideshow-principal'], 
        queryFn: () => slideshowHomeprincipal(),
    });

    return { data, isLoading }
}

